import type { Edge } from "@xyflow/react"

import type { AppNode, BranchChildNodeData } from "../types"

export function getUpstreamNodeIds(nodes: AppNode[], edges: Edge[], nodeId: string): string[] {
  const incomingEdges = new Map<string, Edge[]>()
  for (const edge of edges) {
    const existing = incomingEdges.get(edge.target) ?? []
    existing.push(edge)
    incomingEdges.set(edge.target, existing)
  }

  const nodeMap = new Map(nodes.map((node) => [node.id, node]))
  const visited = new Set<string>()
  const queue = (incomingEdges.get(nodeId) ?? []).map((edge) => edge.source)
  const upstreamNodeIds: string[] = []

  while (queue.length > 0) {
    const currentId = queue.shift()!
    if (visited.has(currentId)) continue
    visited.add(currentId)

    const currentNode = nodeMap.get(currentId)
    if (!currentNode) continue
    upstreamNodeIds.push(currentId)

    for (const edge of incomingEdges.get(currentId) ?? []) {
      if (!visited.has(edge.source)) queue.push(edge.source)
    }

    if (currentNode.type === "branchChild") {
      const parentId = (currentNode.data as BranchChildNodeData).parentId
      if (parentId && !visited.has(parentId)) queue.push(parentId)
    }
  }

  return upstreamNodeIds
}
